<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div class="momfident-video p-4 p-md-5 rounded-4 text-center">
    <h2 class="title mb-4">{{ $t('about-title') }}</h2>
    <div class="video-wrapper position-relative mx-auto">
      <iframe
          class="rounded-4 w-100"
          :src="`https://www.youtube.com/embed/${t('about-video-id')}`"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.momfident-video {
  background-color: #fdeef2;

  .title {
    font-family: $font-thin;
    font-size: $font-size-lg;
    color: $color-pink-dark-2;
  }

  .video-wrapper {
    max-width: 720px;

    iframe {
      aspect-ratio: 16 / 9;
      background-color: #000;
    }
  }
}
</style>
